module.exports = __webpack_public_path__ + "media/src/images/icons/icons-2e81fa2d9b33448f595af8f187b27362.svg";